module.exports = __webpack_public_path__ + "static/2_years_stacked-c638a2763e46febcc25503f3d25542ec.png";